module.exports = __webpack_public_path__ + "img/frame (151).b48af93c.jpg";